<template>
    <vue-dropzone ref="Dropzone" id="uploadWidget" 
        :options="dropzoneOptions" 
        v-on:vdropzone-file-added="fileAdded"
        v-on:vdropzone-success="uploadSuccess"
        v-on:vdropzone-removed-file="fileRemoved"
    >
    </vue-dropzone>
    
</template>


<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Dropzone from 'dropzone'
import 'dropzone/dist/dropzone.css'


export default {
    name: 'Dropzone',
    components: {
        vueDropzone: vue2Dropzone
    },
    methods: {
        uploadSuccess: function(file, response) {
            console.log("file uploaded successfully was " + file.name);
            //this.myfiles.push(file);
            //this.sendFiles(this.myfiles);
        },
        fileAdded: function(file) {
            console.log("file added to the dropzone " + file.name);
            this.myfile = file;
            this.sendFile(this.myfile);
        },
        sendFile: function(sent_file) {
            this.$emit('file', sent_file);
        },
        fileRemoved: function(file, error, xhr) {
            console.log("file to remove is " + file.name);  
            this.myfile = null;
        }
    },
    data: function() {
        
        return {
            myfile: null,
            dropzoneOptions: {
                autoProcessQueue: false,
                paramName: 'file[]',
                url: '/upload',
                uploadMultiple: true,
                addRemoveLinks: true,
                thumbnailWidth: 300,
                dictDefaultMessage: "<i class='fa fa-cloud-upload'>  Drag or Upload your file</i>",
            }
        }
    }
}
</script>


<style>
    @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

    .dropzone .dz-preview .dz-progress {
        display: none !important;
    }

    .dropzone {
        border: 0.5px dashed #ccc;
        font-size:1.3rem;
        color:#888;
        background-color:#fff;
    }

    .fa.fa-cloud-upload{
        margin-right:20px;
    }

    .dropzone .dz-preview .dz-remove {
        color:#f25792;
        margin-bottom:-50px;
        font-size:0.8rem;
        font-variant-caps: all-small-caps;
    }

    .dropzone .dz-preview .dz-remove:hover {
        text-decoration-color: #f25792;
        
    }

</style>
